import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { MAX_ONE_CLICK_QRE_SET_NAME_LENGTH } from 'src/app/core/models/one-click-qre-set.model';
import { OneClickQRESetService } from 'src/app/core/services/one-click-qre-set.service';

export interface OneClickQRESetNameDialogData {
  title: string;
  confirmLabel: string;
  initialName?: string;
  excludeSetId?: string;
  allowExistingName?: boolean;
}

@Component({
  selector: 'csi-one-click-qre-set-name-dialog',
  templateUrl: './one-click-qre-set-name-dialog.component.html',
  styleUrls: ['./one-click-qre-set-name-dialog.component.css']
})
export class OneClickQRESetNameDialogComponent implements OnInit, OnDestroy {
  public nameControl = new FormControl('', [
    Validators.required,
    Validators.maxLength(MAX_ONE_CLICK_QRE_SET_NAME_LENGTH)
  ]);
  public nameErrorKey = '';
  public maxNameLength = MAX_ONE_CLICK_QRE_SET_NAME_LENGTH;
  public nameLength = 0;

  constructor(
    public dialogRef: MatDialogRef<OneClickQRESetNameDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) public data: OneClickQRESetNameDialogData,
    private oneClickQRESetService: OneClickQRESetService
  ) {}

  public static open(matDialog: MatDialog, data: OneClickQRESetNameDialogData) {
    return matDialog.open<OneClickQRESetNameDialogComponent, OneClickQRESetNameDialogData, string>(
      OneClickQRESetNameDialogComponent,
      {
        width: '24rem',
        data
      }
    );
  }

  ngOnInit() {
    if (this.data && this.data.initialName) {
      this.nameControl.setValue(this.data.initialName);
    }
    this.nameLength = (this.nameControl.value || '').length;
    this.nameControl.valueChanges.pipe(untilDestroyed(this)).subscribe(value => {
      this.nameLength = (value || '').length;
      if (this.nameErrorKey) {
        this.refreshNameError();
      }
    });
  }

  ngOnDestroy() {}

  public onSave() {
    const trimmedName = this.refreshNameError();
    if (this.nameErrorKey) {
      return;
    }
    this.dialogRef.close(trimmedName);
  }

  private refreshNameError(): string {
    const name = this.nameControl.value || '';
    const excludeSetId = this.data && this.data.excludeSetId;
    const allowExistingName = this.data && this.data.allowExistingName;
    const validation = this.oneClickQRESetService.validateName(
      name,
      excludeSetId,
      allowExistingName
    );
    this.nameErrorKey = validation.valid ? '' : validation.errorKey;
    return validation.trimmedName;
  }
}
